import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.2.3_@babel+core@7.28.6_@playwright+test@1.58.2_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.2.3_@babel+core@7.28.6_@playwright+test@1.58.2_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/contact/contact.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewTracker"] */ "/opt/build/repo/src/components/analytics/PageViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalContactForm"] */ "/opt/build/repo/src/components/contact/LocalContactForm.client.tsx");
